/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';

import { MessageContainer } from './styles';

const PaymentMessage = ({ children, className }) => (
    <MessageContainer className={className}>
        {children}
    </MessageContainer>
);

PaymentMessage.defaultProps = {
    className: '',
};

PaymentMessage.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.string,
    ]).isRequired,
    className: PropTypes.string,
};

export default PaymentMessage;
